module.exports = __webpack_public_path__ + "static/img/zycp_yanjiuxing_a.d5c091a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/test/zycp_yanjiuxing_a.jpg
// module id = J+H1
// module chunks = 1